import { Link, NavLink, Route, Routes } from 'react-router-dom'
import Inschrijven from './pages/Inschrijven'
import Bedankt from './pages/Bedankt'
import MijnPlek from './pages/MijnPlek'
import VorigeEditie from './pages/VorigeEditie'
import Beheer from './pages/Beheer'
import Plekken from './pages/Plekken'
import Toewijzen from './pages/Toewijzen'
import Kaart from './pages/Kaart'
import Home from './pages/Home'
import Reglement from './pages/Reglement'
import Praktisch from './pages/Praktisch'

export default function App() {
  return (
    <div className="min-h-screen bg-lime text-ink flex flex-col">
      {/* Top lime band — borrowed straight from fluweelfeest.be header pattern */}
      <div className="topbar">
        <div className="mx-auto max-w-5xl px-5 py-2 flex items-center justify-between text-xs font-display tracking-display uppercase">
          <span>Fluweelfeest · Rommelmarkt</span>
          <a href="https://fluweelfeest.be" className="hover:underline" target="_blank" rel="noreferrer">fluweelfeest.be</a>
        </div>
      </div>

      <header className="bg-ink text-lime border-b-[3px] border-ink">
        <div className="mx-auto max-w-5xl px-5 py-5 flex items-center justify-between gap-6">
          <Link to="/" className="flex items-center gap-3 leading-none">
            <img src="/img/logo-rond.png" alt="" className="h-12 w-12 sm:h-14 sm:w-14" />
            <span className="font-display text-3xl sm:text-5xl tracking-display">Rommelmarkt</span>
          </Link>
          <nav className="flex flex-wrap justify-end gap-x-4 gap-y-1 font-display text-lg sm:text-xl uppercase tracking-display">
            <Tab to="/inschrijven">Inschrijven</Tab>
            <Tab to="/praktisch">Praktisch</Tab>
            <Tab to="/reglement">Reglement</Tab>
          </nav>
        </div>
      </header>

      <main className="pb-16 flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/inschrijven" element={<Inschrijven />} />
          <Route path="/bedankt" element={<Bedankt />} />
          <Route path="/mijn-plek/:token" element={<MijnPlek />} />
          <Route path="/mijn-plek/:token/vorige-editie" element={<VorigeEditie />} />
          <Route path="/praktisch" element={<Praktisch />} />
          <Route path="/reglement" element={<Reglement />} />
          <Route path="/beheer" element={<Beheer />} />
          <Route path="/beheer/plekken" element={<Plekken />} />
          <Route path="/beheer/toewijzen" element={<Toewijzen />} />
          <Route path="/beheer/kaart" element={<Kaart />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <footer className="bg-ink text-offwhite">
        <div className="mx-auto max-w-5xl px-5 py-6 text-sm flex flex-col sm:flex-row gap-3 justify-between items-center">
          <span>Vragen? <a className="text-lime underline" href="mailto:rommelmarkt@fluweelfeest.be">rommelmarkt@fluweelfeest.be</a></span>
          <a href="https://fluweelfeest.be" target="_blank" rel="noreferrer" className="block">
            <img src="/img/fflogo.png" alt="Fluweelfeest" className="h-8 w-auto" />
          </a>
        </div>
      </footer>
    </div>
  )
}

function Tab({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `pb-1 border-b-[3px] transition ${isActive ? 'border-lime text-lime' : 'border-transparent text-lime/80 hover:text-lime'}`
      }
    >
      {children}
    </NavLink>
  )
}

function NotFound() {
  return (
    <div className="container-narrow py-16">
      <h1 className="font-display text-6xl mb-3">Niet gevonden</h1>
      <p className="text-muted">Klopt de link nog? <Link to="/" className="text-ink underline">Terug naar start</Link>.</p>
    </div>
  )
}
